<template>
  <div class="cfo-tool-page">
    <div class="page-header">
      <div class="brand">
        <div class="brand-logo">C</div>
        <div>
          <div class="brand-name">{{ title }}</div>
          <div class="brand-sub">{{ subtitle }}</div>
        </div>
      </div>
      <div class="meta">
        <div class="meta-time">{{ period }}</div>
        <div v-if="tag" class="meta-tag">{{ tag }}</div>
      </div>
    </div>
    <div class="container">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: 'ToolPageLayout',
  props: {
    title: { type: String, required: true },
    subtitle: { type: String, default: '财务总监智擎工作台 · 创智物联' },
    period: { type: String, default: '报告周期：2026年5月（月结完成）' },
    tag: { type: String, default: 'SAP CO-FI核对一致 · 月结已锁定' }
  }
}
</script>

<style lang="scss" scoped>
@import './tool-page.scss';
</style>
